import { styled } from '../../../styled/index'

export default styled.div`
  width: 20px;
  height: 20px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/TopBar/Positioner.tsx